import { observable, computed, action } from 'mobx';

import { post } from '../../../services/request';

import Step1 from './Step1';
import Summary from './Summary';

export default class Store {
  steps = [
    {
      key: 'reject-message',
      title: 'Message to rejected',
      implementation: Step1,
    },
  ];

  @observable offers;

  @observable rejectMessage = '';

  summaryClass = Summary;

  @computed get selectedBuyer() {
    if (!this.offers) return [];

    const [awarded] = this.offers.filter((o) => o.status === 'awarded');

    return awarded || {};
  }

  @computed get offersToReject() {
    if (!this.offers) return [];

    return this.offers
      .filter(
        (item) => item.status === 'confirmed' || item.status === 'accepted'
      )
      .sort((a, b) => b.submittedValue - a.submittedValue);
  }

  constructor(management) {
    this.offers = management.source.offers.viewModel.offers.map((item) => {
      return {
        item,
        buyerId: item.buyerId,
        name: `${item.buyer.buyer_lastName}, ${item.buyer.buyer_firstName}`,
        submittedValue: item.submittedValue,
        validity: item.data.offer_validity,
        status: item.status,
      };
    });
  }

  handleRejectMessageChange = action((value) => {
    this.rejectMessage = value;
  });

  @action async submit(saleId, token) {
    await post(
      `/api/v1/wizard/${saleId}/award/confirm`,
      {
        buyerId: this.selectedBuyer.buyerId,
        rejectMessage: this.rejectMessage,
      },
      token
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/ConfirmAward/index.js